import { useEffect } from "react";
import { useNavigate } from "react-router";

export default function ColdBoot() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie = "";

    navigate("/login");
  }, []);

  return <div>Rebooting...</div>;
}
